<template>
  <div class="collapsible" v-bind:class="{ activecollapse:activecollapse}"  @mouseenter="fnSetHover(true)" @mouseleave="fnSetHover(false)"  @click="fnChangeCollapse" >{{displaylabel}}</div>
  <div class="content" v-bind:class="{ contentshow:activecollapse, contenthide:!activecollapse}">
    <slot></slot>
  </div>
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpcollapsible",
  mixins:[multilangmixin],
  props:["title","slogan"],
  emits:["sigcollapse"],

  data(){
      return {
                activecollapse:false,
                hover:false
            };
  },

  created(){
    
  },

  computed:{

    displaylabel(){
      if (this.activecollapse==true)
      {
        return this.slogan;
      }
      else
      {
        if (this.hover==true)
        {
          return this.slogan;
        }
        else
        {
          return this.title;
        }
      }

    }

  },


  methods:{
      fnSetHover(piFlag)
      {
        this.hover=piFlag;
      },
      fnChangeCollapse()
      {
        this.activecollapse=!this.activecollapse;
        if (this.activecollapse==false)
        {
          this.hover=false;
        }
        this.$emit("sigcollapse");
      }

  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
.collapsible {
  color: black;
  
  border: none;
  text-align: left;
  
  outline: none;
  font-weight: 800;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  
  font-size: 0.9em;
}

.activecollapse
{
  color: #ffdd00;
  
} 

.collapsible:hover {
  color: #ffdd00;
}

.content {
  
 
  overflow: hidden;
  font-size: 2em;
  font-weight: 600;
    
}

.content a img {
 width: 6vh;
}

.content p a, .content div a, .content a {
  color: black;
  text-decoration: none;  
}

.content p a:visited, .content div a:visited, .content a:visited {
  color: black;
  text-decoration: none;  
}

.content p a:active, .content div a:active, .content a:active {
  color: black;
  text-decoration: none;  
}
 
.content p a:hover, .content div a:hover, .content a:hover {
  color: black;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: #ffdd00;
  text-decoration-thickness: 0.3em;
}





.contenthide
{
  /*display:none;*/
  transition:max-height 0.3s ease-out;
  max-height: 0;
}

.contentshow
{
  display:block;
  transition: max-height 0.3s ease-out;
   max-height: 630px;
  
}


  .content {
          font-size: 0.5em;
        }

  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
       

      
  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  


       
  }


</style>
